<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
    <notifications position="top center" />
  </div>
</template>

<script>
export default {
  name: "app",
  computed: {
    token() {
      return this.$store.getters.token;
    },
  },
  methods: {
    async fetchUser() {
      await this.$store.dispatch("fetchUser");
    },
  },
  async mounted() {
    if (this.token) {
      await this.fetchUser();
    }
  },
};
</script>

<style lang="css">
@font-face {
  font-family: "Calibre";
  src: url("~/assets/fonts/CalibreWeb-Regular.eot"),
       url("~/assets/fonts/CalibreWeb-Regular.woff") format("woff"),
       url("~/assets/fonts/CalibreWeb-Regular.woff2") format("woff2");
  font-weight: normal;
}
@font-face {
  font-family: "Calibre";
  src: url("~/assets/fonts/CalibreWeb-Bold.eot"),
       url("~/assets/fonts/CalibreWeb-Bold.woff") format("woff"),
       url("~/assets/fonts/CalibreWeb-Bold.woff2") format("woff2");
  font-weight: bold;
}
@font-face {
  font-family: "Calibre";
  src: url("~/assets/fonts/CalibreWeb-Semibold.eot"),
       url("~/assets/fonts/CalibreWeb-Semibold.woff") format("woff"),
       url("~/assets/fonts/CalibreWeb-Semibold.woff2") format("woff2");
  font-weight: 600;
}

body {
  color: var(--black);
  background: var(--background);
  font-family: var(--calibre);
}

/* navigation shared css */
.primary-link {
  color: var(--primary);
  font-weight: var(--semibold);
  text-decoration: none;
  font-size: var(--xs);
}

/* badge css */
.badge {
  color: var(--white);
  padding: var(--spacing-1) var(--spacing-2);
  background-color: var(--primary-light);
  font-size: var(--xs);
  border-radius: var(--border-radius-sm);
  font-weight: var(--semibold);
  white-space: nowrap;
  width: max-content;
  width: fit-content;
}

.badge--primary-light {
  background: var(--primary-light);
}

.badge--alert {
  background-color: var(--primary);
}

.badge--danger {
  background-color: var(--red-light);
}

.badge--fine {
  background-color: var(--rumie-green);
}

.badge--processing {
  background-color: var(--tertiary);
}

/*vue-file-agent*/

.vue-file-agent.file-input-wrapper {
  border: var(--border-3) solid var(--primary-border) !important;
  border-radius: var(--border-radius-lg);
}

.theme-list .vue-file-agent .file-preview-wrapper .file-preview .file-progress {
  top: -1px !important;
}

.theme-list .vue-file-agent .file-preview-wrapper .file-preview .file-progress {
  width: calc(100% - 54px) !important;
  height: 7px !important;
  border-radius: 0% !important;
}

.vue-file-agent .file-preview .file-name {
  top: 5px !important;
}

.content-upload-summary .vue-file-agent .file-progress-bar {
  background: #d50000 !important;
}

.content-upload-summary .vue-file-agent .file-progress-full .file-progress-bar {
  background: #54d500 !important;
}

.fa-times:hover {
  cursor: pointer;
}


/* select  css */
.v-select {
  min-width: 200px;
  background: var(--grey-lighter);
  border-radius: var(--border-radius-md);
  box-sizing: border-box;
}

.vs__dropdown-toggle {
  border: none !important;
  max-height: 100%;
}

.vs__selected-options {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.vs__actions {
  margin-left: var(--spacing-2);
}

.vs__search {
  color: var(--grey-dark) !important;
}

.v-select .vs__dropdown-toggle {
  background: var(--grey-lighter);
  padding: var(--spacing-2) var(--spacing-4) !important;
  padding-left: var(--spacing-1) !important;
  box-sizing: border-box;
}

.vs--single.vs--open .vs__selected {
  bottom: 0px;
  top: 0px;
}

/* validation message */
.validation--error {
  color: var(--red-dark);
  margin-top: var(--spacing-2);
  margin-bottom: var(--spacing-2);
  font-weight: var(--medium);
  font-size: var(--xs);
}

/* modal css */
.v--modal {
  overflow-y: auto !important;
}
.modal__header {
  font-weight: var(--bold);
  padding: var(--spacing-4);
  border-bottom: var(--border-2) solid var(--grey-lighter);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.modal__header .fas.fa-times {
  cursor: pointer;
  color: var(--grey);
}

.modal__body,
.modal__footer {
  max-width: var(--mobile);
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  padding: var(--spacing-4);
}

.modal__footer {
  margin-top: var(--spacing-2);
}

/*vue circle progress bar*/

.percent-text {
  margin-bottom: 170px;
  font-size: var(--xl) !important;
}

.circle-percent-text-body {
  height: 10% !important;
}

/*Drag and Drop*/

.smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper.server-table__data {
  overflow: visible !important;
  background: white;
  display: table-row !important;
}

/*tooltip css*/
.tooltip-icon {
  color: var(--grey-light) !important;
  cursor: help;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: var(--grey-background-tooltip);
  color: var(--grey-color-text);
  border-radius: var(--border-radius-md);
  font-size: var(--xs);
  padding: var(--spacing-2);
  max-width: 200px;
}

.tooltip .tooltip-arrow {
  display: none;
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 10px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
</style>
